import SimpleSchema from '../schema'
import { SimpleSchema2Bridge } from 'uniforms-bridge-simple-schema-2'

const ResetPasswordSchema = new SimpleSchema({ password: { type: String, min: 8, label: 'Password' } })

export default new SimpleSchema2Bridge(ResetPasswordSchema)
